import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest, HttpResponse } from '@angular/common/http';
import { environment as env } from '../../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
const BASE_URL = env.baseurl;

@Injectable({
  providedIn: 'root'
})
export class ApiBaseService {
  BASE_URL: string;
  private options = { headers: new HttpHeaders().set('Content-Type', 'application/json') };


  constructor(private _httpClient: HttpClient) {
    this.BASE_URL = BASE_URL;
  }

  public get(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    return this._httpClient.get(BASE_URL + path, { params }).pipe(catchError(this.formatErrors));
  }

  public getScan(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    return this._httpClient.get( path, { params }).pipe(catchError(this.formatErrors));
  }

  public put(path: string, body: object = {}): Observable<any> {
    return this._httpClient
      .put(BASE_URL + path, JSON.stringify(body), this.options)
      .pipe(catchError(this.formatErrors));
  }

  public post(path: string, body: object = {}): Observable<any> {

    var item = this._httpClient
      .post(BASE_URL + path, body, this.options)
      .pipe(catchError(this.formatErrors));

    return item;
  }

  public download(path: string, id:number) {


    let headers = new HttpHeaders().set('Content-Type', 'application/json');


    return this._httpClient.get(BASE_URL + path + "?id=" + id, { headers, responseType: 'blob' as 'json' });

  }

  public postForm(path: string, body: FormData): Observable<any> {
    return this._httpClient
      .post(BASE_URL + path, body)
      .pipe(catchError(this.formatErrors));
  }

  public delete(path: string): Observable<any> {
    return this._httpClient.delete(BASE_URL + path).pipe(catchError(this.formatErrors));
  }


  public uploadFile(path: string, formData: any): Observable<any> {
    const req = new HttpRequest(
      'POST', BASE_URL + path, formData, {
      reportProgress: true //This is required for track upload process
    });
    return this._httpClient.request(req);
  }

  public downloadFile(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    return this._httpClient.get(BASE_URL + path, { responseType: 'blob' })
  }

  public formatErrors(error: any): Observable<any> {
    return throwError(error.error);
  }

}

